RivalIQ.apps.Discovery.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    RivalIQ.apps.Discovery.views.DimensionAnalysisNameCell = Marionette.ItemView.extend({
        tagName: 'td',
        className: 'metric-table-cell discovery-name-cell',
        template: '#discoverySearchFilterCellTemplate',

        initialize: function () {
            const me = this;
            me.model.attributes.hidePostsUrl = true;
        },

        templateHelpers: function () {
            const me = this;

            // assumption here, but the table view won't work unless there's only one free dimension
            const filterDimension = _.head(RivalIQ.metric.getFreeDimensions(me.model.attributes));
            const data = me.getOption('data');
            const newFilterTerm = _.last(data).trim();

            const dashboardModel = me.getOption('table');
            const executeSearchUrl = App.utils.getFilterUrl(filterDimension, newFilterTerm, dashboardModel);
            let analyzeAccountUrl = '';
            if (filterDimension === 'mention') {
                analyzeAccountUrl = App.utils.getAnalyzeAccountUrl(dashboardModel, newFilterTerm);
            }

            const child = {};
            // Set the relevant dimension to undefined to get the correct name
            child[filterDimension] = undefined;
            const metric = me.model.build(child);

            return _.extend({
                name: metric.format(data[0]),
                executeSearchUrl: executeSearchUrl,
                filterDimension: filterDimension,
                filterValue: newFilterTerm,
                postWord: RivalIQ.data.channels.get(dashboardModel.getProp('channel')).get('postName'),
                analyzeAccountUrl: analyzeAccountUrl
            }, RivalIQ.utils.emoji.getTemplateHelpers());
        }
    });

});
